export * from "./FlavorFinderResultsCardSpec";
